import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export const EMBEDDED_BODY_CLASS = 'vib-embedded-in-panel'

// Marca <body> cuando la pantalla se está sirviendo DENTRO del panel lateral del área
// profesional (`?open_from=panel`, que `panelParam.utils` mantiene en cada navegación).
// El panel ya aporta su propia cabecera, así que la de eproject sobra: la oculta el CSS
// colgado de esta clase (ProfessionalShell.scss y PageHeader.scss, los dos headers posibles
// según el toggle `emulateNewMenuProfessional`).
//
// Va montado en el root y reacciona a `useLocation`, no solo al montaje: dentro del panel se
// navega entre pantallas (colección → configurador) y la clase debe seguir el parámetro.
// Fuera del panel no añade nada, así que el legacy queda intacto.
const EmbeddedInPanelBodyClass = () => {
	const location = useLocation()

	useEffect(() => {
		const embedded = new URLSearchParams(location.search).get('open_from') === 'panel'
		document.body.classList.toggle(EMBEDDED_BODY_CLASS, embedded)
	}, [location.search])

	return null
}

export default EmbeddedInPanelBodyClass
